module.exports = __webpack_public_path__ + "img/point_bg.955f2ba1.png";